import m from "./../../../dist/es2015/themes/Kelly.js";
export const am5themes_Kelly = m;